import React, { useState, useEffect } from 'react'
import { useSelector, shallowEqual, useDispatch } from 'dva'
import { Toast } from 'antd-mobile'
import { Button } from 'components'
import { onGeetest } from 'utils'
import Input from '../Input'
import styles from './index.module.less'

const allTime = 60

const selector = ({ loading }) => ({
  loading: loading.effects['login/sendSms'],
})

export default function Index({ mobile = {}, ...props }: any) {
  const dispatch = useDispatch()
  const { loading } = useSelector(selector, shallowEqual)
  const [codeTime, setCodeTime] = useState(allTime)

  // 发送验证码
  const sendCode = async () => {
    if (!mobile.mobile) return Toast.fail('手机号码不存在，请修改后重试！')
    if (!/^1[3-9]\d{9}$/.test(mobile.mobile)) {
      Toast.fail('请输入正确的手机号码')
      return
    }
    let data = await dispatch({
      type: 'login/sendSms',
      payload: mobile,
    })
    data && setCodeTime(codeTime - 1)
  }

  useEffect(() => {
    if (codeTime === allTime) return
    setTimeout(() => {
      let time = codeTime
      time--
      time === 0 && (time = allTime)
      setCodeTime(time)
    }, 1000)
  }, [codeTime])

  return (
    <div className={styles.codeInput}>
      <Input placeholder="请输入验证码" {...props} />
      <Button
        type="primary"
        className={styles.but}
        loading={loading}
        onClick={sendCode}
        disabled={codeTime < allTime}
        shape="round"
        ghost={true}>
        {codeTime === allTime ? '发送验证码' : `重新发送(${codeTime})`}
      </Button>
    </div>
  )
}
